import { render, staticRenderFns } from "./OfertaDetailComponent.vue?vue&type=template&id=6eecbd9c&scoped=true"
import script from "./OfertaDetailComponent.vue?vue&type=script&lang=js"
export * from "./OfertaDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./OfertaDetailComponent.vue?vue&type=style&index=0&id=6eecbd9c&prod&scoped=true&lang=css"
import style1 from "./OfertaDetailComponent.vue?vue&type=style&index=1&id=6eecbd9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eecbd9c",
  null
  
)

export default component.exports